<div class="content" mat-dialog-content>
    <h3 mat-dialog-title style="font-size: 24px;">Terms & Agreements</h3>
    <div class="row">
        <p *ngIf="isAgent">E-consent is required to start the loan. Please verify the borrower's consent.</p>
    </div>
    
    <div>
       <form [formGroup]="econsentForm">
        <p *ngIf="isAgent"><strong>Borrower Terms & Agreements</strong></p>
        <div class="row">
            <div class="col-12 checkbox-container-custom">
                <mat-checkbox formControlName="consentToDoBusiness"></mat-checkbox>
                <div class="checkbox-label-container">
                    I {{isAgent ? '(Borrower)' : ''}} consent to do business electronically
                </div>
            </div>
            <a style="padding-left: 37px; font-weight: 700;" (click)="openViewTermsModal('consentToBusiness')">View Terms</a>
            <div class="Vert-15"></div>
            <div class="Vert-15"></div>
        </div>
        <div class="row" *ngIf="isClient">
            <div class="col-12 checkbox-container-custom">
                <mat-checkbox formControlName="consentToReceiveMessages"></mat-checkbox>
                <div class="checkbox-label-container">
                    I consent to receive messages from my lender for status updates on my loan
                </div>
            </div>
            <a style="padding-left: 3px; font-weight: 700;" (click)="openViewTermsModal('consentToMessages')">View Terms</a>
            <div class="Vert-15"></div>
            <div class="Vert-15"></div>
        </div>
        <div class="row" *ngIf="isAgent">
            <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                <mat-label>Date Consent Given</mat-label>
                <input matInput [matDatepicker]="picker" placeholder="Choose a date" formControlName="consentDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
       </form>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-button class="btn btn-primary" [disabled]="econsentForm.invalid"
            (click)="openLoanApp()">Open Loan App</button>
    </div>
</div>
